<template>
  <v-layout row justify-center>
    <v-dialog v-model="contactDialog" max-width="500px" persistent>
    <v-card>
      <v-progress-linear v-if="loading" indeterminate color="primary"></v-progress-linear>
      <v-toolbar dark color="primary">
      <v-btn icon @click.native="close" dark>
        <v-icon>close</v-icon>
      </v-btn>
      <v-toolbar-title>Contact Info</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn dark flat @click.native="saveContact" :disabled="customerID === null || !newContactValid">Save</v-btn>
      </v-toolbar-items>
      </v-toolbar>
      <v-form ref="newContact" v-model="newContactValid">
      <v-container>
      <v-layout row>
      <v-flex>
        <v-text-field 
        label="Contact Name" 
        v-model="contactEditedItem.Name"
        :rules="[v => !!v || 'Name is required']" 
        required>
        </v-text-field>
        <v-text-field 
        label="Email Address" 
        v-model="contactEditedItem.EmailAddress"
        :rules="[v => !!v || 'E-mail is required', v => /.+@.+/.test(v) || 'E-mail must be valid']" 
        required
        :append-outer-icon="'mdi-send'"
        @click:append-outer="doLink('EmailAddress', 'mailto')">
        </v-text-field>
        <v-text-field 
        label="Phone" 
        v-model="contactEditedItem.Phone"
        :rules="[v => !!v || 'phone is required']" 
        :append-outer-icon="'mdi-phone'"
        @click:append-outer="doLink('Phone', 'tel')"
        required>
        </v-text-field>
        <v-text-field 
        label="Mobile" 
        v-model="contactEditedItem.Mobile"
        :append-outer-icon="'mdi-phone'"
        @click:append-outer="doLink('Mobile', 'tel')"
        required>
        </v-text-field>
        <v-autocomplete 
        browser-autocomplete="disabled"
        label="Company" 
        :items="customerArray"
        item-text="name"
        item-value="key"
        v-model="customerID"
        :rules="[v => !!v || 'Company Name is required']" 
        required>
        </v-autocomplete>
        <v-select 
        label="Sites" 
        v-model="contactEditedItem.Site"
        :items="sites"
        chips
        item-text="Name"
        item-value="id"
        :rules="[v => !!v || 'Site Name is required']" 
        multiple
        required>
        </v-select>
        <v-card-title>Contact Type</v-card-title>
        <v-layout row justify>
          <v-flex xs12 sm4 md4>
        <v-checkbox
              v-model="contactEditedItem.Accounts"
              label="Accounts"
              color="primary"
            ></v-checkbox>
          </v-flex>
            <v-flex xs12 sm4 md4>
        <v-checkbox
              v-model="contactEditedItem.Fleet"
              label="Fleet"
              color="primary"
              hide-details
            ></v-checkbox>
          </v-flex>
            <v-flex xs12 sm4 md4>
        <v-checkbox
              v-model="contactEditedItem.Comms"
              label="Comms"
              color="primary"
            ></v-checkbox>
          </v-flex>
        </v-layout>
      </v-flex>
      </v-layout>
      </v-container>
      </v-form>
      <a :href="'mailto:' + contactEditedItem.EmailAddress" ref="link"></a>
    </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { fireStore } from '../../firebase'
export default {
  props: ['siteID', 'contactDialog', 'contactID', 'customers', 'customer'],
  data () {
    return {
      contactEditedItem: {
        Name: ''
      },
      contactDefaultItem: {
        Name: ''
      },
      customerID: null,
      customerArray: [],
      newContactValid: false,
      loading: false,
      sites: []
    }
  },
  watch: {
    contactID () {
      this.getContact()
    },
    customer (val) {
      this.customerID = val || null
    },
    contactDialog () {
      this.getSites()
      this.customerArray = []
      for (let item in this.customers) {
        this.customerArray.push({key: item, name: this.customers[item].customerName})
      }
      this.customerArray.sort((a, b) => {
        return a.name < b.name ? -1 : a.name > b.name ? 1 : 0
      })
      this.$refs.newContact.validate()
    },
    customerID (val) {
      this.contactEditedItem.Customer = val
    }
  },
  methods: {
    close () {
      this.$emit('update:contactDialog', false)
    },
    doLink (value, type) {
      this.$refs.link.href = type + ':' + this.contactEditedItem[value]
      this.$refs.link.click()
    },
    getContact () {
      this.contactEditedItem = {}
      if (this.contactID !== null) {
        this.loading = true
        fireStore.collection('Contacts').doc(this.contactID)
        .get()
        .then(doc => {
          this.contactEditedItem = doc.data()
          this.headOffice = this.customers[doc.data().Customer].headOffice == this.contactID
          this.loading = false
          this.getSites()
        })
      } else {
        this.contactEditedItem.Customer = this.customerID
        this.getSites()
      }
    },
    getSites () {
      this.sites = []
      if (this.customerID !== null) {
        fireStore.collection('Sites').where('Customer', '==', this.customerID)
        .get()
        .then(snap => {
          snap.forEach(doc => {
            let data = doc.data()
            data.id = doc.id
            this.sites.push(data)
          })
          if (this.contactID === null) {
            if (this.siteID) {
              this.contactEditedItem.Site = [this.siteID]
            } else if (this.customers[this.customerID].headOffice) {
              this.contactEditedItem.Site = [this.customers[this.customerID].headOffice]
            }
          }
        })
      }
    },
    saveContact () {
      if (this.contactID !== null) {
        fireStore.collection('Contacts').doc(this.contactID).set(this.contactEditedItem, {merge: true})
        .then(() => {
          this.$emit('getContacts')
          this.close()
        })
      } else {
        fireStore.collection('Contacts').add(this.contactEditedItem)
        .then((docRef) => {
          this.contactEditedItem.id = docRef.id
          this.$emit('getContacts')
          this.close()
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// ContactEditDialog.vue?0d463186